import React from 'react';
import { Redirect } from 'react-router-dom';
import CalendarView from './CalendarView';
import CurrentUser from '../../CurrentUser';

class ScheduledProjects extends React.Component {

  constructor(props) {
    super(props);

    this.onViewDetails = this.onViewDetails.bind(this);

    this.state = {
      projectId: null,
      toDetails: false,
      returnPath: '/projects/scheduled'
    };
  }

  onViewDetails(projectId) {
    this.setState({ projectId, toDetails: true });
  }

  render() {

    if (this.state.toDetails) {
      return <Redirect to={{ pathname: `/projects/${this.state.projectId}/summary`, state: { returnPath: this.state.returnPath } }} />
    }

    return <CurrentUser render={currentUser =>
      currentUser ? (
        <CalendarView onViewDetails={this.onViewDetails} user={currentUser} />
      ) : null} />
  }
}

export default ScheduledProjects;



// WEBPACK FOOTER //
// ./src/components/projects/ScheduledProjects/index.js